import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { BusinessRulesService } from './../services/business-rules.service';

/*
    Directive that uses business rules to determine whether an element should be removed from the DOM
*/
@Directive({
  selector: '[showUnless]',
})
export class ShowUnlessDirective {
  private hasView = false;
  private config: any;
  private context: any;

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private businessRulesService: BusinessRulesService,
  ) {}

  @Input() set showUnless(config: any) {
    this.config = config;
    this.determineShowOrHide();
  }

  @Input() set showUnlessContext(context: any) {
    this.context = context;
    this.determineShowOrHide();
  }

  private determineShowOrHide() {
    if (!(this.config && this.context) && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (this.config && this.context && this.hasView) {
      const hideConditionalAction =
        this.businessRulesService.retrieveResultFromBusinessRule(
          this.config.conditions,
          this.context,
        );

      if (hideConditionalAction) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    }
  }
}
